export const environment = {
  production: true,
  apiBase: '/api/public',
  authBase: '/api/auth',
  apiApp: '/api/app',
  apiAdmin: '/api/admin',
  siteUrl: 'https://centrodelongevidad.com',
  appUrl: 'https://app.centrodelongevidad.com',
  adminUrl: 'https://admin.centrodelongevidad.com',
};
